export default {
    app_version: '2.0.14',
    app_name: 'BLINDTEST_USER',
    base_url: (process.env.NODE_ENV == "development") ?  "http://localhost:4000/api" : "/api",
    api_timeout: 10000,
    mqtt: {
        host: 'wss://broker.emqx.io:8084/mqtt',
        // host: 'wss://mqtt.jmco.ch:9001/mqtt',
        // user: 'mqtt-user',
        // pass: 'KUQAg3Tqr4MsEn5',
        topic: 'blindtest/master/#',
    },
    userTopic: 'blindtest/user/',
    startKey: 'start',
    stopKey: 'stop',
    colors: {
        logo_blue: '#00adaf',
        logo_pink: '#f677a9',
        logo_yellow: '#fcf0e1',
        logo_black: '#252027',
        background: '#ecc1a1',
        background_gradient: 'linear-gradient(30deg,rgba(236, 193, 161, 1) 0%, rgba(213, 182, 216, 1) 76%)',
        ranking_background: '#f2f2f2',  // gray
        font_color: '#11485a',  // petrol blue
        ranking_highlight: '#c9dae4',  // light blue
        connection_font_color: 'gray'
        
    }
}